/*
 * サブシステム名：XXXX
 * 機能名：勤怠実績登録
 */
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import dolly from '@/rahmen/utils/dolly'
import filter from '@/rahmen/utils/filters'
import validators from '@/rahmen/validators'

import header from '@/ddv2.library/header'
import indexeddb from '@/ddv2.library/indexeddb'

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'

const DdCheckbox = () => import('@/components/DdCheckbox.vue')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox.vue')
const DdDateBox = () => import('@/components/DdDateBox.vue')
const DdDropDown = () => import('@/components/DdDropDown.vue')
const DdNumericBox = () => import('@/components/DdNumericBox.vue')
const DdRadioButton = () => import('@/components/DdRadioButton.vue')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextBox = () => import('@/components/DdTextBox')
const DdTimeBox = () => import('@/components/DdTimeBox')

export default {
  name: 'PrmKintaiJissekiEdit',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdCheckbox,
    DdCodeTextBox,
    DdDateBox,
    DdDropDown,
    DdNumericBox,
    DdRadioButton,
    DdSubHeader,
    DdTextBox,
    DdTimeBox
  },
  data: () => ({
    id: 0,
    rec: {},
    invalidMessages: {},
    modeOfEdit: 2,
    modeKengen: 2,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstJininHeaders: header.mstJininHeaders,
    showCopyDialog: false
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      currentKaishaCode: 'users/currentKaishaCode',
      usersId: 'users/userId',
      shubetsuList: 'DDMasters/mstShubetsu',
      kubunList: 'DDMasters/msysKubun',
      eigyoshoList: 'DDMasters/mstEigyosho',
      jininList: 'DDMasters/vwCMstEigyoshoJininList',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg',
      userEigyoshoCd: 'users/eigyoshoCd'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    filteredEigyoshoList () {
      const self = this
      const target = filter.dateFormatter(new Date())
      return self.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        // 選択済みの人員で抽出
        var jinin = false
        if (self.rec.jininId) {
          jinin = indexeddb.getRecord(self.jininList, self.rec.jininId)
          self.rec.jininId = jinin ? self.rec.jininId : null
        }
        return (elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target) &&
               (jinin ? jinin.eigyoshoCd === elem.eigyoshoCd : true)
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },
    filteredJininList () {
      const self = this
      const target = filter.dateFormatter(new Date())
      return self.jininList.map((elem) => {
        elem.jininNm = elem.jininNmSei + (elem.jininNmMei ? ' ' + elem.jininNmMei : '')
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        // 選択済みの営業所で抽出
        var eigyosho = false
        if (self.rec.shozokuEighosyoId) {
          eigyosho = indexeddb.getRecord(self.eigyoshoList, self.rec.shozokuEighosyoId)
          self.rec.shozokuEighosyoId = eigyosho ? self.rec.shozokuEighosyoId : null
        }
        return (elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target) &&
               (eigyosho ? eigyosho.eigyoshoCd === elem.eigyoshoCd : true)
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.jininCd > elem2.jininCd) { return 1 }
        if (elem1.jininCd === elem2.jininCd) { return 0 }
        return -1
      })
    },
    isDeleteDisable () {
      return this.id === 0
    },
    filteredShuroKbn () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF999')
    },
    filteredKinmuKbn () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT026')
    },
    filteredKyujitsuShukkinKbn () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'KBN041')
    },
    isShoukaiMode () {
      return this.modeOfEdit === 1
    },
    isRirekiFukusyaDisplay () {
      console.log('モード', this.modeOfEdit, this.modeKengen)
      if (this.modeOfEdit === 2 && (this.modeKengen === 1 || this.modeKengen === 2)) {
        return true
      }
      return false
    },
    isCancelButtonDisplay () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1) {
        return false
      }
      return true
    },
    isDeleteButtonDisplay () {
      // if (this.modeKengen === 2 && (this.modeOfEdit === 0 || this.modeOfEdit === 2)) {
      if (this.modeKengen === 2 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isCopyButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isSaveButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    },
    isReadOnlyDisplay () {
      if (this.modeOfEdit !== 0) {
        return true
      }
      return false
    }
  },
  created () {
    this.id = this.$route.params.id
    if (this.id === '0') {
      this.id = 0
    }
  },
  mounted () {
    this.initialize()
  },
  methods: {
    getCloneTargetMethod: function () {
      return this.rec
    },
    beforeRouteLeaveByMenu: function (next) {
      const opt = {
        nextCallback: next
      }

      this.preventTransition(opt)
    },
    fetchData: function () {
      const self = this
      return new Promise((resolve) => {
        console.log('★fetchData', self)
        console.log('★going to get', self.id)
        this.HttpClient
          .get(`/api/v1/D2prmd1020/find?id=${self.id}`)
          .then((data) => {
            self.rec = data.payload
            // 日付項目
            delete self.rec.kinmuYmd
            delete self.rec.shukkinYmd
            delete self.rec.taikinYmd
            // 時間項目
            delete self.rec.shukkinHms
            delete self.rec.taikinHms
            delete self.rec.kyukeiJikan1From
            delete self.rec.kyukeiJikan1To
            delete self.rec.kyukeiJikan2From
            delete self.rec.kyukeiJikan2To
            delete self.rec.kyukeiJikan3From
            delete self.rec.kyukeiJikan3To
            delete self.rec.kyukeiJikan4From
            delete self.rec.kyukeiJikan4To
            delete self.rec.kyukeiJikan5From
            delete self.rec.kyukeiJikan5To
            // 表示項目
            self.rec.jissekiShimeFlgDisp = self.rec.jissekiShimeFlg ? '実績締済' : ''
            var tantosha = self.jininList.length > 0 ? indexeddb.getRecord(self.jininList, self.rec.torokuTantoshaId) : null
            if (tantosha) {
              self.rec.torokuTantoshaNm = tantosha.jininNmSei + (tantosha.jininNmMei ? ' ' + tantosha.jininNmMei : '')
            }
            self.convertToDispType().then(() => {
              self.cloneData = dolly.clone(self.getCloneTargetMethod())
            })
            console.log('recived data', this.rec)
            resolve()
          })
      })
    },
    initialize () {
      const self = this
      const option = {
        loadMasters: ['msyskubun', 'mstshubetsu', 'msteigyosho', 'vwcmsteigyoshojininlist'],
        initializeInputPromise: () => {
          return new Promise((resolve) => {
            const today = filter.dateFormatter(new Date())
            self.rec = {
              kintaiJissekiNo: '',
              jissekiKakuninZumiFlg: false,
              jissekiShimeFlg: false,
              torokuTantoshaNm: '',
              shozokuEighosyoId: self.eigyoshoList.length > 0 ? indexeddb.getRecordByCd(self.currentKaishaCode, self.eigyoshoList, 'eigyoshoCd', self.userEigyoshoCd, today).id : null,
              jininId: '',
              kinmuYmdString: '',
              shuroKbn: null,
              kinmuKbn: null,
              kyujitsuShukkinKbn: null,
              tenjoFlg: false,
              shukkinYmdString: '',
              shukkinHmsString: '',
              taikinYmdString: '',
              taikinHmsString: '',
              kosokuJikan: '',
              kadouJikan: '',
              kyukeiJikan: '',
              zangyoJikan: '',
              shinyaJikan: '',
              shinyaZangyoJikan: '',
              kyukeiJikan1FromString: '',
              kyukeiJikan1ToString: '',
              kyukeiJikan2FromString: '',
              kyukeiJikan2ToString: '',
              kyukeiJikan3FromString: '',
              kyukeiJikan3ToString: '',
              kyukeiJikan4FromString: '',
              kyukeiJikan4ToString: '',
              kyukeiJikan5FromString: '',
              kyukeiJikan5ToString: '',
              kinmuTeateKingaku1: '',
              kinmuTeateKingaku2: '',
              kinmuTeateKingaku3: '',
              kinmuTeateKingaku4: '',
              kinmuTeateKingaku5: '',
              kinmuTeateKingaku6: '',
              kinmuTeateKingaku7: '',
              kinmuTeateKingaku8: '',
              kinmuTeateKingaku9: '',
              kinmuTeateKingaku10: '',
              kinmuTeatePoint1: '',
              kinmuTeatePoint2: '',
              kinmuTeatePoint3: '',
              kinmuTeatePoint4: '',
              kinmuTeatePoint5: '',
              kinmuTeatePoint6: '',
              kinmuTeatePoint7: '',
              kinmuTeatePoint8: '',
              kinmuTeatePoint9: '',
              kinmuTeatePoint10: '',
              renrakuBiko: ''
            }
            console.log('initializeInputPromise')
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          return new Promise((resolve) => {
            console.log('★savedInputRestorePromise', c)
            console.log('★savedInputRestorePromise', self.rec)
            // ユーザ保存項目の復元
            self.rec = { ...self.rec, ...c }
            console.log('★savedInputRestorePromise', self.rec)
            resolve()
          })
        },
        existsIdMethod: () => {
          return self.id !== 0
        },
        requestApiPromise: self.fetchData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            // thisId == 0 then 新規モード
            if (self.id === 0) {
              self.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              self.modeOfEdit = 1 // 照会モード
            } else {
              self.modeOfEdit = 2 // 更新モード
            }

            self.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        },
        settingItemMethod: (kengen) => {
          console.log('settingItemMethod', kengen)
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, option)
      this.initializeForRegister(option)
    },
    onReturnButtonClick: function (e) {
      console.log('onReturnButtonClick', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }

      this.transitionBack(opt)
    },
    onCancelButtonClick: function (e) {
      console.log('onCancelButtonClick', e)
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            self.rec = data()
            self.rec.id = self.id
            // 複写後のキャンセル押下で車両コードが残りエラーとなるため、id=0の場合は車両コードを空にする
            if (self.rec.id === 0) { self.rec.kintaiJissekiNo = '' }
            resolve()
          })
        }
      }

      this.cancelInputs(opt)
    },
    onDeleteButtonClick: function (e) {
      const tempViewsData = Object.assign({}, this.rec)
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.delete(`/api/v1/D2prmd1020/Delete?id=${self.id}&tm=${self.rec.timestamp}`).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        failureResponsePromise: () => {
          return new Promise(resolve => {
            this.rec = tempViewsData
            this.convertToDispType()
            resolve()
          })
        }
      }
      this.delete(opt)
    },
    onCopyButtonClick: function (e) {
      const self = this
      const opt = {
        setIdMethod: () => {
          self.id = 0
          self.rec.id = 0
          // 自動採番のため複写対象としない
          self.rec.kintaiJissekiNo = ''
          self.modeOfEdit = 0
          console.log('clear id', this.rec)
        }
      }
      this.copyInputs(opt)
    },
    onSaveButtonClick: function (e) {
      console.log('save', this)
      const tempViewsData = Object.assign({}, this.rec)
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.id = data.payload.id
            resolve()
          })
        },
        judgeKeyChangedMethod: (data) => {
          return false
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            this.id = id
            this.transition(1, { id: id }, this.initialize)
            console.log('★transition')
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        getSavedInputMethod: function () {
          console.log('★getSavedInputMethod')
          return {
          }
        },
        failureResponsePromise: () => {
          return new Promise(resolve => {
            this.rec = tempViewsData
            this.convertToDispType()
            resolve()
          })
        }
      }

      this.register(opt)
    },
    registerPromise: function () {
      this.convertToDBType()
      let f
      if (this.id === 0) {
        console.log('★登録処理')
        console.log('★rec', this.rec)
        f = this.HttpClient.post('/api/v1/D2prmd1020/Create', this.rec)
      } else {
        console.log('★更新処理')
        console.log('★rec', this.rec)
        f = this.HttpClient.put(`/api/v1/D2prmd1020/Update?id=${this.id}`, this.rec)
      }
      return f
    },
    registerValidate: function () {
      var ret = true
      console.log('validate start', this.cloneData)
      // 出勤年月日と退勤年月日
      const msg = validators.compareDate(this.rec.shukkinYmdString, this.rec.taikinYmdString)
      console.log('date check end', msg)
      if (msg !== undefined) {
        this.$refs.shukkinYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.taikinYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.setInvalidSummaryMessage('COME0014')
        ret = false
      }
      // 出勤時刻と退勤時刻（同日の場合）
      if (this.rec.shukkinYmdString && (this.rec.shukkinYmdString === this.rec.taikinYmdString)) {
        const msg2 = validators.compareTime(this.rec.shukkinHmsString, this.rec.taikinHmsString)
        console.log('time check end', msg2)
        if (msg2 !== undefined) {
          this.$refs.shukkinHmsString[this.Ctrls.SET_INVALID_METHOD](msg2)
          this.$refs.taikinHmsString[this.Ctrls.SET_INVALID_METHOD](msg2)
          this.setInvalidSummaryMessage('COME0012')
          ret = false
        }
      }
      return ret
    },
    inputAttendanceTimesElement: function () {
      var msg
      if (this.rec.shukkinYmdString && this.rec.taikinYmdString) {
        msg = validators.compareDate(this.rec.shukkinYmdString, this.rec.taikinYmdString)
        if (msg !== undefined) {
          this.$refs.shukkinYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.taikinYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
        this.$refs.shukkinYmdString[this.Ctrls.SET_INVALID_METHOD](undefined)
        this.$refs.taikinYmdString[this.Ctrls.SET_INVALID_METHOD](undefined)
      }
      if (this.rec.shukkinYmdString && this.rec.shukkinHmsString && this.rec.taikinYmdString && this.rec.taikinHmsString) {
        msg = validators.compareDateTime(this.rec.shukkinYmdString, this.rec.shukkinHmsString, this.rec.taikinYmdString, this.rec.taikinHmsString)
        if (msg !== undefined) {
          this.$refs.shukkinYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.shukkinHmsString[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.taikinYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.taikinHmsString[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
        this.$refs.shukkinYmdString[this.Ctrls.SET_INVALID_METHOD](undefined)
        this.$refs.shukkinHmsString[this.Ctrls.SET_INVALID_METHOD](undefined)
        this.$refs.taikinYmdString[this.Ctrls.SET_INVALID_METHOD](undefined)
        this.$refs.taikinHmsString[this.Ctrls.SET_INVALID_METHOD](undefined)

        // 出庫帰庫年月日時刻より、拘束・残業・深夜・深夜残・休憩時間を算出する。
        if (this.rec.jininId > 0) {
          this.calculationAttendanceTimes(this.usersId, this.rec.shukkinYmdString, this.rec.shukkinHmsString, this.rec.taikinYmdString, this.rec.taikinHmsString, this.rec.kyukeiJikan ?? '')
            .then((res) => {
              const jomuinKintaiInfo = Object.assign({}, this.rec)
              jomuinKintaiInfo.kosokuJikan = res.kosokuJikan ? (res.kosokuJikan).slice(0, 5) : null
              jomuinKintaiInfo.zangyoJikan = res.zangyoJikan ? (res.zangyoJikan).slice(0, 5) : null
              jomuinKintaiInfo.kadouJikan = res.kadouJikan ? (res.kadouJikan).slice(0, 5) : null
              jomuinKintaiInfo.shinyaJikan = res.shinyaJikan ? (res.shinyaJikan).slice(0, 5) : null
              jomuinKintaiInfo.shinyaZangyoJikan = res.shinyaZangyoJikan ? (res.shinyaZangyoJikan).slice(0, 5) : null
              jomuinKintaiInfo.kyukeiJikan = res.kyukeiJikan ? (res.kyukeiJikan).slice(0, 5) : null
              this.rec = Object.assign({}, jomuinKintaiInfo)
            })
        }
      }
    },
    calculationAttendanceTimes: function (loginId, shukkoYmd, shukkoHms, kikoYmd, kikoHms, kyukei) {
      return new Promise((resolve) => {
        this.HttpClient
          .get(`/api/v1/ApiLibrary/CalculationAttendanceTimes?id=${loginId}&shukkinYmdString=${shukkoYmd}&shukkinHmsString=${shukkoHms}&taikinYmdString=${kikoYmd}&taikinHmsString=${kikoHms}&kyukeiString=${kyukei}`)
          .then((data) => {
            resolve(data.payload)
          })
      })
    },
    // ----------------------------------------------------------------------------------------------------
    // 画面表示用フォーマット変換
    // ----------------------------------------------------------------------------------------------------
    convertToDispType: function () {
      return new Promise(resolve => {
        const tmpData = Object.assign({}, this.rec)
        if (String(tmpData.kosokuJikan)) {
          tmpData.kosokuJikan = filter.minToIntervalTimeFormatter(tmpData.kosokuJikan)
        }
        if (String(tmpData.kadouJikan)) {
          tmpData.kadouJikan = filter.minToIntervalTimeFormatter(tmpData.zangyoJikan)
        }
        if (String(tmpData.zangyoJikan)) {
          tmpData.zangyoJikan = filter.minToIntervalTimeFormatter(tmpData.zangyoJikan)
        }
        if (String(tmpData.shinyaJikan)) {
          tmpData.shinyaJikan = filter.minToIntervalTimeFormatter(tmpData.shinyaJikan)
        }
        if (String(tmpData.shinyaZangyoJikan)) {
          tmpData.shinyaZangyoJikan = filter.minToIntervalTimeFormatter(tmpData.shinyaZangyoJikan)
        }
        if (String(tmpData.kyukeiJikan)) {
          tmpData.kyukeiJikan = filter.minToIntervalTimeFormatter(tmpData.kyukeiJikan)
        }
        this.rec = Object.assign({}, tmpData)
        resolve()
      })
    },
    // ----------------------------------------------------------------------------------------------------
    // DB処理用フォーマット変換
    // ----------------------------------------------------------------------------------------------------
    convertToDBType: function () {
      const tmpData = Object.assign({}, this.rec)
      if (tmpData.kosokuJikan) {
        tmpData.kosokuJikan = filter.timeToMinFormatter(tmpData.kosokuJikan)
      }
      if (tmpData.zangyoJikan) {
        tmpData.zangyoJikan = filter.timeToMinFormatter(tmpData.zangyoJikan)
      }
      if (tmpData.kadouJikan) {
        tmpData.kadouJikan = filter.timeToMinFormatter(tmpData.kadouJikan)
      }
      if (tmpData.shinyaJikan) {
        tmpData.shinyaJikan = filter.timeToMinFormatter(tmpData.shinyaJikan)
      }
      if (tmpData.shinyaZangyoJikan) {
        tmpData.shinyaZangyoJikan = filter.timeToMinFormatter(tmpData.shinyaZangyoJikan)
      }
      if (tmpData.kyukeiJikan) {
        tmpData.kyukeiJikan = filter.timeToMinFormatter(tmpData.kyukeiJikan)
      }
      this.rec = Object.assign({}, tmpData)
    },
    inputKosokuJikan: function () {
      if (this.rec.kosokuJikan) {
        this.$set(this.rec, 'kosokuJikan', this.calcTime(String(this.rec.kosokuJikan)))
      }
    },
    inputKadouJikan: function () {
      if (this.rec.kadouJikan) {
        this.$set(this.rec, 'kadouJikan', this.calcTime(String(this.rec.kadouJikan)))
      }
    },
    inputKyukeiJikan: function () {
      if (this.rec.kyukeiJikan) {
        this.$set(this.rec, 'kyukeiJikan', this.calcTime(String(this.rec.kyukeiJikan)))
      }
    },
    inputZangyoJikan: function () {
      if (this.rec.zangyoJikan) {
        this.$set(this.rec, 'zangyoJikan', this.calcTime(String(this.rec.zangyoJikan)))
      }
    },
    inputShinyaJikan: function () {
      if (this.rec.shinyaJikan) {
        this.$set(this.rec, 'shinyaJikan', this.calcTime(String(this.rec.shinyaJikan)))
      }
    },
    inputShinyaZangyoJikan: function () {
      if (this.rec.shinyaZangyoJikan) {
        this.$set(this.rec, 'shinyaZangyoJikan', this.calcTime(String(this.rec.shinyaZangyoJikan)))
      }
    },
    calcTime: function (p) {
      var result = ''
      if (p.indexOf(':') !== -1) {
        p = p.replace(':', '')
      }
      if (p.length < 3) {
        result = filter.minToIntervalTimeFormatter(parseInt(p, 10))
      } else {
        var min = parseInt(p.slice(0, p.length - 2), 10) * 60 + parseInt(p.slice(-2), 10)
        result = filter.minToIntervalTimeFormatter(min)
      }
      return result
    },
    deleteValidate: function () {
      return true
    }
  }
}
